<template>
    <div class="approval-color-picker" ref="wrapper">
        <div class="color"
             :style="{backgroundColor: value, cursor: 'pointer'}"
             v-b-tooltip.hover :title="$t('Click to change color')"
             @click="toggle"></div>

        <div v-if="open" class="approval-color-popup shadow-sm">
            <div class="color-selector">
                <div v-for="preset in presets"
                     :key="preset"
                     class="color"
                     :class="{selected: value === preset}"
                     @click="select(preset)">
                    <span :style="{backgroundColor: preset}"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ApprovalColorPicker',
    props: {
        value: {
            type: String,
            default: '#D1D5DB'
        }
    },
    data() {
        return {
            open: false,
            presets: [
                '#991B1B', '#DC2626', '#F87171', '#FCA5A5',
                '#D97706', '#F97316', '#FCD34D', '#FBBF24',
                '#065F46', '#16A34A', '#4ADE80', '#86EFAC',
                '#1D4ED8', '#3B82F6', '#60A5FA', '#93C5FD',
                '#7C3AED', '#A855F7', '#E5007E', '#F472B6',
                '#312782', '#1D1D1B', '#6B7280', '#D1D5DB',
            ]
        };
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        select(color) {
            this.$emit('input', color);
            this.open = false;
        },
        onOutsideClick(e) {
            if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
                this.open = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.onOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.onOutsideClick);
    }
};
</script>

<style scoped>
.approval-color-picker {
    position: relative;
    display: inline-block;
}

.approval-color-popup {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 1050;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 10px;
    width: 220px;
}

.approval-color-popup .color-selector {
    display: grid;
    grid-template-columns: repeat(8, 18px);
    gap: 8px;
}

.approval-color-popup .color-selector .color {
    margin-right: 0;
}

.approval-color-popup .color-selector .color.selected:before {
    content: "";
    width: 24px;
    height: 24px;
    border-radius: 0;
    background-color: #E20613;
    position: absolute;
    top: -3px;
    left: -3px;
    z-index: 1;
}
</style>
